var EXIF = require('exif-js')

const EXIF_ORIENTATION_ANGLE_MAPPINGS = {
  1: 0, // Upright
  // 2: // flipped horizontally
  3: 180, // upside down
  // 4: // flipped vertically
  // 5: // flipped horizontally and rotated 90 ccw
  6: 90, // 90 degree ccw
  // 7: // flipped horizontally and rotated 270 ccw
  8: 270 // 270 degree ccw
}

const getExifNumber = (imageFile) => {
  return new Promise((resolve, reject) => {
    EXIF.getData(imageFile, function () {
      const allMetaData = EXIF.getAllTags(this)
      const hasOrientation = (allMetaData && allMetaData.Orientation)

      let exifNumber = (hasOrientation)
        ? allMetaData.Orientation
        : 1

      resolve(exifNumber)
    })
  })
}

const getExifOrientationFromExifNumber = (exifNumber) => {
  return EXIF_ORIENTATION_ANGLE_MAPPINGS[exifNumber]
}

const getExifData = (imageFile) => {
  return new Promise((resolve, reject) => {
    getExifNumber(imageFile).then((exifNumber) => {
      resolve({
        exifNumber,
        exifOrientation: getExifOrientationFromExifNumber(exifNumber)
      })
    })
  })
}

export {
  getExifData
}



// WEBPACK FOOTER //
// ./uncommon-client/utilities/exif.js